module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('vue-excel-xlsx', {
    staticClass: "btn btn-primary",
    attrs: {
      "data": _vm.data,
      "columns": _vm.columns,
      "filename": 'orçamentos-corretivas',
      "sheetname": 'sheetname'
    }
  }, [_vm._v("\n    Orçamentos Corretivas\n  ")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0303ac13!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/planilha/orcamento/ExportOrcamentosAprovados.vue
// module id = 940
// module chunks = 1